import { useTranslation } from 'react-i18next';
import { cx } from './cx.js';
import { SUIT_LINE, SUIT_TINTS, SuitGlyph } from './SuitLine.js';

/**
 * The lockup in live type, at the artwork's own proportions: the suit line
 * flush left over the name (BRAND § The lockup).
 *
 * `SuitLine` stops at 24 points and a packed gap, and the lockup wants 40 on
 * a laptop with air between, so the line is drawn from `SuitGlyph`, the same
 * paths the artwork was generated from. The name is the screen's heading.
 *
 * One lockup for every arrival screen: the cover while the app loads, the
 * Welcome screen and the home (`lobby-splash`, `lobby-home`). They had drifted
 * apart once (dev-notes 2026-09-07), so they share this one now, and the cover
 * in `index.html` is drawn from it (`test/cover.test.tsx`).
 */
export function Lockup({ className }: { readonly className?: string }): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <div className={cx('flex w-fit flex-col items-start', className)}>
      <div className="flex gap-3 tablet:gap-5">
        {SUIT_LINE.map((suit) => (
          <SuitGlyph
            key={suit}
            suit={suit}
            className={cx(SUIT_TINTS[suit], 'size-6 tablet:size-10')}
          />
        ))}
      </div>
      {/* `home-name` is the phone size, scaled to fit a narrow phone (`home.css`). */}
      <h1 className="home-name mt-2 leading-none font-extrabold tracking-tight whitespace-nowrap tablet:mt-4 tablet:text-8xl">
        {t('app.title')}
      </h1>
    </div>
  );
}
